/** Largura do drawer permanente; manter alinhado a `shell.page.tsx`. */
export const APP_DRAWER_WIDTH = 280;
